module.exports = __webpack_public_path__ + "assets/img/station10.d09b8ba9.png";